module.exports = __webpack_public_path__ + "static/media/gresillement.e3dc7d5b.mp3";